import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

class TablaColegios extends React.Component {
  state = {
    column: null,
    data: this.props.listaColegios,
    direction: null
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({ data: nextProps.listaColegios });
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: "ascending"
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending"
    });
  };

  render() {
    const { column, data, direction } = this.state;

    return (
      <Table sortable celled fixed>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              sorted={column === "nombre" ? direction : null}
              onClick={this.handleSort("nombre")}
            >
              Nombre
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "Poblacion" ? direction : null}
              onClick={this.handleSort("poblacion")}
            >
              Población
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "provincia" ? direction : null}
              onClick={this.handleSort("provinia")}
            >
              Provincia
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {_.map(data, d => (
            <Table.Row
              key={d.id}
              onClick={() => this.props.handleRowClick(d.id)}
            >
              <Table.Cell>{d.nombre}</Table.Cell>
              <Table.Cell>{d.poblacion}</Table.Cell>
              <Table.Cell>{d.provincia}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }
}

export default TablaColegios;



// WEBPACK FOOTER //
// ./src/pages/listados/listadoColegios/TablaColegios.jsx